import { InventoryDTO } from "../DTO/inventoryDTO";
import { FileData } from "../interfaces/interfaces";
import { PropertyService } from "../services/PropertyService";
import { Address } from "./address";
import { Client } from "./client";
import { County } from "./county";
import { InventoryImage } from "./inventoryImage";
import { State } from "./state";

export class Inventory{
    public id?:number;
    public businessId!:string;
    public propertyId!:string;
    public clientId?:number;
    public stateId?:number;
    public countyId?:number;
    public taxYear?:number;
    public defendant?:string;
    public address:Address;
    public status?:number;
    public activePropertyId?:number;
    public addedByUser?:string;
    public added?:Date;
    public lastEditedByUser?:string;
    public edited?:Date;

    public images?:InventoryImage[];

    public static importableAttributes:string[]=['Tax Year','Defendant','Street Address 1','Street Address 2','City','State','Zip Code','Country','Township','Address'];

    private _client:Client|undefined;

    set client(value:Client|undefined){
        this._client=value;
        if(value) this.clientId=value.id;
    }
    get client(){
        return this._client;
    }

    public rawData!:FileData[];

    constructor(){
        this.address = new Address();
    }

    public static mapToDTO(param:Inventory) : InventoryDTO{
        
        let dto = new InventoryDTO();
        try
        {
            dto.id = param.id;
            dto.businessId = param.businessId;
            dto.propertyId = param.propertyId;
            dto.clientId = param.clientId;
            dto.stateId = param.stateId;
            dto.countyId = param.countyId;
            dto.taxYear = param.taxYear;
            dto.defendant = param.defendant
            if(param.address) dto.address = Address.mapToDTO(param.address);
            if(param.rawData) dto.rawData=JSON.stringify(param.rawData);
            dto.status = param.status;
            dto.activePropertyId = param.activePropertyId;
            dto.addedByUser = param.addedByUser;
            if(param.added) dto.added = param.added.toISOString();
            dto.lastEditedByUser = param.lastEditedByUser;
            if(param.edited) dto.edited = param.edited.toISOString();
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
    public static mapFromDTO(param:InventoryDTO) : Inventory
    {
        
        let obj = new Inventory();
        try
        {
            obj.id = param.id;
            obj.businessId = param.businessId;
            obj.propertyId = param.propertyId;
            obj.clientId = param.clientId;
            obj.stateId = param.stateId;
            obj.countyId = param.countyId;
            obj.taxYear = param.taxYear;
            obj.defendant = param.defendant;
            if(param.address) obj.address = Address.mapFromDTO(param.address);
            obj.status = param.status;
            obj.activePropertyId = param.activePropertyId;
            obj.addedByUser = param.addedByUser;
            if(param.added) obj.added = new Date(param.added);
            obj.lastEditedByUser = param.lastEditedByUser;
            if(param.edited) obj.edited = new Date(param.edited);
            if(param.rawData) obj.rawData=JSON.parse(param.rawData);
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public static async mapFromImport(fdArray:FileData[], businessId:string, client:Client, county:County, taxYearDefault:number, propertyService:PropertyService):Promise<Inventory>{
        if (!fdArray) throw new Error("FileData object is null")
        let obj = new Inventory();
        try
        {
            obj.businessId = businessId;
            obj.clientId = client.id;
            obj.stateId = county.stateId;
            obj.countyId = county.id;
            let taxYear=fdArray.find(fd=>fd.key=="Tax Year");
            obj.taxYear = (taxYear?.value?.length==4)?taxYear.value:taxYearDefault;
            obj.defendant = fdArray.find(fd=>fd.key=="Defendant")?.value;
            let a = new Address();
            let address = fdArray.find(fd=>fd.key=="Address")?.value;
            if(address){
                await propertyService.getStructuredAddress(address).then(sa=>{ a=sa!; });
            }
            else{
                a.streetAddress1 = fdArray.find(fd=>fd.key=="Street Address 1")?.value;
                a.streetAddress2 = fdArray.find(fd=>fd.key=="Street Address 2")?.value;
                a.city = fdArray.find(fd=>fd.key=="City")?.value;
                a.state = fdArray.find(fd=>fd.key=="State")?.value;
                a.zipCode = fdArray.find(fd=>fd.key=="Zip Code")?.value;
            }
            a.township = fdArray.find(fd=>fd.key=="Township")?.value;
            a.county=county.name;
            a.country="US";
            obj.address = a; 
            obj.rawData=fdArray.find(fd=>fd.key=="rawData")?.value;
            obj.client = client;
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public matchesFilter(filterString:string) : boolean{
        let filter = JSON.parse(filterString) as Filter;
        return (!filter.filterValue || this.propertyId.toLowerCase().includes(filter.filterValue) || this.defendant?.toLowerCase().includes(filter.filterValue) || this.address?.formattedAddress.toLowerCase().includes(filter.filterValue) || this.rawData.findIndex(rd=>rd.value.toLowerCase().includes(filter.filterValue))>-1) &&
        (!filter.state || this.stateId==filter.state?.id) && (!filter.county || this.countyId==filter.county?.id) && (!filter.client ||this.clientId == filter.client?.id) && (!filter.taxYear ||this.taxYear==filter.taxYear);
    }

    get exportHeaders(){
        let headerArray:string[] = ["PropertyId","Client","State","County","TaxYear","Defendant","Address"];
        if(this.rawData) headerArray = headerArray.concat(this.rawData.map(rd => rd.key));
        return headerArray;
    }
}

export class Filter{
    public filterValue?:string;
    public client?: Client;
    public state?: State;
    public county?: County;
    public taxYear?: number;
}

